import { gql } from "@apollo/client";

export const SEND_CUSTOMER_LOGIN_CREDENTIAL = gql`
  mutation sendCustomerLoginCredential($customerId: ID!) {
    sendCustomerLoginCredential(customerId: $customerId) {
      success
      message
    }
  }
`;